var _path, _path2, _path3, _path4, _path5, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPowerAutomate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 54,
    viewBox: "0 0 67 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.63054 0C2.62895 0 2.62578 0 2.62419 0C0.372721 0 -0.830708 2.65579 0.656533 4.34915L20.6074 27.0478L44.1829 0.345649C43.8008 0.185509 43.3886 0.0919619 42.9652 0.0903763L2.63054 0Z",
    fill: "url(#paint0_linear_567_1599)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5778 12.7673L45.3352 1.15798C45.0149 0.794895 44.6185 0.522181 44.1825 0.339844L20.607 27.0436L0.719506 49.5821C-0.788347 51.2913 0.415082 53.9725 2.68558 53.9931L19.7857 53.982L55.5778 12.7673Z",
    fill: "url(#paint1_linear_567_1599)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3477 23.8446L55.5792 12.7695L19.7871 53.9985L43.2468 53.9826C44.0491 53.9097 44.8007 53.5498 45.3382 52.9393L65.3477 30.2533C66.9634 28.4236 66.9634 25.6759 65.3477 23.8446Z",
    fill: "url(#paint2_linear_567_1599)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M20.6075 27.045L44.183 0.342795C43.8008 0.182655 43.3886 0.0891085 42.9653 0.0875229L42.2946 0.0859375L19.5547 25.8479L20.6075 27.045Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.07,
    d: "M20.083 26.4521L20.6078 27.0483L44.1833 0.346126C43.909 0.230381 43.6157 0.165374 43.3176 0.128906L20.083 26.4521Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_567_1599",
    x1: 11.5397,
    y1: -8.90918,
    x2: 34.4683,
    y2: 15.9427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9D34E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#932A9E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_567_1599",
    x1: 22.4843,
    y1: 26.0415,
    x2: 39.2213,
    y2: 46.4079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A841E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A82DC0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_567_1599",
    x1: 38.5631,
    y1: 32.1322,
    x2: 48.2556,
    y2: 48.3666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B24CE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B03CC5"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerAutomate);
export default __webpack_public_path__ + "static/media/power-automate.02b9ab25d4d03836a1257efd40edb97e.svg";
export { ForwardRef as ReactComponent };